var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"w-56 p-4 space-y-1 border-r border-gray-200 bg-white shrink-0 relative z-30"},[_c('ul',{attrs:{"role":"list"}},_vm._l((_vm.pages),function(item){return _c('PageItem',_vm._b({attrs:{"selected":item.id === _vm.selected},nativeOn:{"click":function($event){_vm.selected = item.id}}},'PageItem',item,false))}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }